import { prepareCommonRailData, sendRail } from "./sendRailCommon";
import { type LinearConfiguration } from "../../Linear/models";
import { prepareApiDataForResetNew, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "../../Linear/redux/types";

export function sendRailDataReset(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonRailData(linearState);
  const resetData = prepareApiDataForResetNew(linearState);

  prepareGroupIdToDisplay(data);

  return sendRail({
    ...data,
    ...resetData,
    railsConfiguratorData: {
      ...data.railsConfiguratorData,
      reset: true,
    },
  });
}
